import React, { useEffect, useState } from "react";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudTable from "../../components/dashboard/table/CrudTable";

import orderService from "../../services/orderService";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader"; // <-- import here
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function AllPendingOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
      "sl",
    "invoice_id",
    "user_name",
    "city",
    "order_status",
    "payment_status",
    "payment_method",
    "product_qty",
    "amount",
    "order_date",
  ];

  const fetchOrders = async () => {
    try {
      const response = await orderService.getPendingOrders();
      const formatted = response.data.orders.map((o, index) => ({
                sl: index + 1,

        ...o,
        user_name: o.user?.username || "N/A",
        city: o.order_address?.city || "N/A",
        product_qty: o.order_products?.length || 0,

        
        created_at: o.created_at,
           order_date: new Date(o.created_at).toLocaleString("en-GB", {
          weekday: "short", 
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true, 
        }),
      }));
      setOrders(formatted);
    } catch (error) {
      console.error("Error fetching pending orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleEdit = (row) => navigate(`/admin/order/${row.id}`);
  const handleDelete = () => {};

  return (
  <DashboardWrapper>
  <div className="container-fluid mt-4">

    <div className="d-flex justify-content-between align-items-center mb-4">
        <h4
            className="mb-0"
            style={{
              fontSize: "20px",
              fontWeight: "500",
              color: "#374151",
            }}
          >
            All  Pending Orders
          </h4>


      <h4 className="mb-0">
    
         <Breadcrumb />
      </h4>
    </div>

    <div className="card shadow">
      {/* <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Pending Orders</h4>
      </div> */}

      <div className="card-body">
        {loading ? (
          <Loader />
        ) : (
          <CrudTable
            data={orders}
            onEdit={handleEdit}
            onDelete={handleDelete}
            columns={columns}
          />
        )}
      </div>
    </div>

  </div>
</DashboardWrapper>
  );
}
